import type { SpatialContainer } from '@/types';
import { useWorkspaceStore, selectActiveDocument } from '@/store/workspaceStore';
import { setCollapsedCommand } from '@/features/objects/objectCommands';
import type { ObjectRendererProps } from './types';
import { IconButton } from '@/components/ui';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from '../ObjectView.module.css';

/**
 * Groups and folders share a frame: a header strip with a collapse toggle; children
 * are rendered by the ObjectLayer as siblings (or not at all while collapsed).
 */
export const ContainerRenderer = ({ object }: ObjectRendererProps<SpatialContainer>) => {
  const toggle = () => {
    const doc = selectActiveDocument(useWorkspaceStore.getState());
    const cmd = doc && setCollapsedCommand(doc, object.id, !object.collapsed);
    if (cmd) useWorkspaceStore.getState().dispatch(cmd);
  };
  return (
    <header className={styles.containerLabel} data-collapsed={object.collapsed || undefined}>
      <IconButton
        className={styles.windowButton}
        label={object.collapsed ? 'Expand' : 'Collapse'}
        aria-expanded={!object.collapsed}
        data-testid="container-toggle"
        onPointerDown={(e) => {
          e.stopPropagation();
        }}
        onClick={toggle}
      >
        {object.collapsed ? <ChevronRightIcon sx={{ fontSize: 16 }} /> : <ExpandMoreIcon sx={{ fontSize: 16 }} />}
      </IconButton>
      <strong>{object.name}</strong>
      <span>
        {object.kind === 'folder' ? '▤ ' : ''}
        {object.childIds.length} item{object.childIds.length === 1 ? '' : 's'}
      </span>
    </header>
  );
};
